<template>
  <base-modal
    title="DÍAS DE VISITA"
    icon="mdi-calendar-multiselect"
    style="max-width: 480px; width: 100%;"
  >

    <div class="d-flex align-center justify-space-between mb-4">
      <span class="text-caption" style="color:#66798C">
        <strong>{{ seleccion.length }}</strong> de {{ dias.length }} días seleccionados
      </span>
      <v-btn text x-small color="primary" @click="toggleTodos">
        {{ todosSeleccionados ? 'Deseleccionar todos' : 'Seleccionar todos' }}
      </v-btn>
    </div>

    <div v-for="(grupo, mesLabel) in diasPorMes" :key="mesLabel" class="mb-4">
      <div class="text-caption font-weight-bold mb-2 mes-label">
        {{ mesLabel }}
      </div>
      <div class="dias-grid">
        <v-checkbox
          v-for="dia in grupo"
          :key="dia.valor"
          v-model="seleccion"
          :value="dia.valor"
          :label="dia.etiqueta"
          dense
          hide-details
          color="primary"
          class="dia-checkbox"
        />
      </div>
    </div>

    <template #actions>
      <v-btn text small @click="$store.dispatch('closeTopModal')">Cancelar</v-btn>
      <v-btn
        color="primary"
        depressed
        small
        :disabled="seleccion.length === 0"
        @click="aplicar"
      >
        Aplicar
      </v-btn>
    </template>

  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal.vue'

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

export default {
  name: 'DiasSelectModal',
  components: { BaseModal },

  props: {
    dias:          { type: Array, default: () => [] },
    seleccionados: { type: Array, default: () => [] },
  },

  data() {
    return {
      seleccion: [...this.seleccionados],
    }
  },

  computed: {
    todosSeleccionados() {
      return this.seleccion.length === this.dias.length && this.dias.length > 0
    },

    diasPorMes() {
      return this.dias.reduce((acc, dia) => {
        const [year, month] = dia.valor.split('-')
        const label = `${MESES[parseInt(month, 10) - 1]} ${year}`
        if (!acc[label]) acc[label] = []
        acc[label].push(dia)
        return acc
      }, {})
    },
  },

  methods: {
    toggleTodos() {
      this.seleccion = this.todosSeleccionados ? [] : this.dias.map(d => d.valor)
    },

    aplicar() {
      this.$emit('apply', [...this.seleccion])
      this.$store.dispatch('closeTopModal')
    },
  },
}
</script>

<style scoped>
.mes-label {
  color: #002245;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  border-bottom: 1px solid #E8EDF2;
  padding-bottom: 4px;
}

.dias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0 8px;
  padding-left: 4px;
}

.dia-checkbox {
  flex-shrink: 0;
}
</style>
